import { forwardRef } from 'react';
// @mui
import Box, { BoxProps } from '@mui/material/Box';
import Link from '@mui/material/Link';
// routes
import { useAuthContext } from 'src/auth/hooks';
import { RouterLink } from 'src/routes/components';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { routePrefix } from 'src/utils/methods/StandardMethods';

// ----------------------------------------------------------------------

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
  // wrapperSx?: any;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, sx, ...other }, ref) => {
    // const theme = useTheme();
    const { user } = useAuthContext();
    // const PRIMARY_LIGHT = theme.palette.primary.light;

    // const PRIMARY_MAIN = theme.palette.primary.main;

    // const PRIMARY_DARK = theme.palette.primary.dark;

    // OR using local (public folder)
    // -------------------------------------------------------
    const logo = (
      <Box
        component="img"
        src="/logo/latestlogo.png"
        // src="/logo/logo_part1_no_bg.png"
        sx={{ width: '70%', height: 'auto', cursor: 'pointer', ...sx }}
      />
    );

    // const logo = (
    //   <Box
    //     ref={ref}
    //     component="div"
    //     sx={{
    //       width: 40,
    //       height: 40,
    //       display: 'inline-flex',
    //       ...sx,
    //     }}
    //     {...other}
    //   >
    //     <Typography variant="h4" sx={{ width: '100%', height: '100%', fontSize: '2em' }}> iDP</Typography>
    //   </Box>
    // );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link
        component={RouterLink}
        href={PATH_DASHBOARD.dashboard.dash(routePrefix(user))}
        sx={{ display: 'block', textAlign: 'center', padding:'0.5rem 0rem' }}
      >
        {logo}
      </Link>
    );
  }
);

export default Logo;
